import { Tag, Tooltip } from "antd";
import { TaskStatuses } from "enums/taskStatuses";
import "./TaskStatusTag.css";
import type React from "react";

type Props = {
  status: any;
  rejectReason?: any;
};

export const TaskStatusTag: React.FC<Props> = ({ status, rejectReason }: Props) => {
  if (!status) {
    return null;
  }

  const colorDict: Record<TaskStatuses, string> = {
    [TaskStatuses.DRAFT]: "volcano",
    [TaskStatuses.SUBMITTED]: "volcano",
    [TaskStatuses.REVIEW]: "volcano",
    [TaskStatuses.APPROVED]: "geekblue",
    [TaskStatuses.REJECTED]: "red",
    [TaskStatuses.PUBLISHING]: "geekblue",
    [TaskStatuses.PUBLISHED]: "green",
  };

  if (rejectReason) {
    return (
      <Tooltip
        classNames={{ root: "task-status-tooltip" }}
        placement="bottom"
        overlay={
          <div>
            <div className="title">Roster Rejected</div>
            <div className="body">{rejectReason}</div>
          </div>
        }
        popupVisible={rejectReason}
      >
        <Tag color={colorDict[status]} style={{ fontSize: "16px" }} className="mt-5">
          {status}
          <i className="fa-regular fa-circle-question ml-5" />
        </Tag>
      </Tooltip>
    );
  }

  return (
    <Tag color={colorDict[status]} style={{ fontSize: "16px" }} className="mt-5">
      {status}
    </Tag>
  );
};
